class CartRemove extends HTMLElement {

	constructor() {

		super();

		this.form = this.closest("cart-wrapper");
		this.item = this.closest("cart-item");

		this.addEventListener("click", this.remove.bind(this));
	}

	remove(event) {

		event.preventDefault();
		event.stopPropagation();

		if (this.item.dataset.box) {

			let indices = this.item.dataset.removes.split(",");

			this.item.multiRemove(indices, this.closest("form"));
			this.item.remove();


			return;
		}

		this.item.updateQuantity(this.item.dataset.index, 0, "quantity", this.item);
	}
}

export default CartRemove;
